export enum TemplateFieldTypes {
    Textzeile,
    Mehrzeilig,
    Datum,
    JaNein,
    Benutzer,
    Zahl = 6,
    Bild,
    Trennlinie,
    RichText = 19,
    ProjectNumber = 20,
    Title = 21,
    Responsible,
    None = 24,
    BlockResponsible,
    BlockDate,
    BlockFinished = 28,
    SerialMeasure,
    ManualAmpel = 31,
    Matrix,
    Category = 37,
    TimeFromTo,
    UserList,
    AuditFindingData,
    AuditPlanMeasures,
    AuditDoMeasures,
    PlannedAudits,
    AuditProcesses,
    Documents,
    MeasureList,
    ColorPicker,
    ParentMeasure,
    StrategyFinanceRating,
    DateDiff,
    ParentContentText,
    ParentContentUser,
    S2030Workpackages,
    S2030Approval,
    S2030MapStrategy,
    HarveyBall,
    Escalation,
    Email,
    S2030Activities,
    S2030Documents,
    ParentContentDate,
    S2030Goals,
    S2030StatusUpdate,
    S2030Milestones,
    S2030TopKpis,
    KurarayVorlage,
    ParentStatus,
    CustomAmpel,
    S2030Ampel,
    NotesList,
    ParentContentUserList,
    LinkMeasures,
    PagPcmsSelfCheckYesNo,
    DataFromSubmeasures,
    ParentContentNumber,
    DataTemplatesMeasureList,
    CustomButton,
    ExternalInterface
};
